<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>New! Contrology<sup>®</sup> Spine Corrector</h2>
        <!-- <h3></h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="contrology-spinecorrector6@1x.jpg"
              src2="contrology-spinecorrector6@2x.jpg"
              alt="Video of Contrology Spine Corrector"
              video
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spinecorrector1@1x.jpg"
              src2="contrology-spinecorrector1@2x.jpg"
              alt="Product photo of Spine Corrector"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spinecorrector2@1x.jpg"
              src2="contrology-spinecorrector2@2x.jpg"
              alt="Product photo of Spine Corrector, angled view"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spinecorrector3@1x.jpg"
              src2="contrology-spinecorrector3@2x.jpg"
              alt="In-use photo of Spine Corrector"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spinecorrector4@1x.jpg"
              src2="contrology-spinecorrector4@2x.jpg"
              alt="In-use photo of Spine Corrector"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology-spinecorrector5@1x.jpg"
              src2="contrology-spinecorrector5@2x.jpg"
              alt="In-use photo of Spine Corrector"
            />
          </photo-grid>

          <!-- <cta-button class="cta-button wide" /> -->

          <div class="content-wrapper">
            <section class="intro">
              <h2>New! Contrology<sup>®</sup> Spine Corrector</h2>
              <!-- <h3></h3> -->
              <p>
                Based on an original step barrel design, the new Contrology Spine Corrector features the precise angles and padding needed for authentic feel and function. The spine corrector is an essential apparatus in every Pilates studio. It is used to perform exercises that lengthen and strengthen the torso, shoulders, back, and legs while correcting or restoring the spine's natural curvature.
                <!-- <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span> -->
              </p>
              <!-- <div v-show="show">
                <p>Specially-developed arm springs provide the authentic feel of the original Pilates chair. The premium upholstered padding is made of dense, resilient foam, for maximum feedback during use.  The Contrology Arm Chair conforms to the original specifications.
                <p>Please review <a href="https://s3.amazonaws.com/s3.pilates.com/resources/Contrology_WeightLimits_CapitalEquipment.pdf" class="content-link">equipment weight limits</a>.
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div> -->
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="15-day lead time"
            />

            <!-- Patent info -->
            <p class="part-number patent-info">
              <a href="https://www.pilates.com/patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="https://www.pilates.com/returns-policy"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >Limited 10-Year Warranty</icon-link>
              <icon-link
                url="/support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <!-- <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link> -->
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <!-- <cta-button class="cta-button" /> -->
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Unique contour profile is same as step barrels made in late 50s and early 60s</li>
              <li>Upholstered with our signature high-density “can’t cheat-em” foam for maximum feedback</li>
              <li>Precise metal handle placement for upper body support in all exercises</li>
              <li>Super strong and lightweight frame is built to last and still easily moves around studio</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p>Width: 16 1/4" (41.28cm)</p>
            <p>Length: 28 ½” (72.4cm)</p>
            <p>Height: 13” (33.0cm)</p>
            <p>Weight: 19lbs. (8.6kg)</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Unique contour profile is same as step barrels made in late 50s and early 60s</li>
                <li>Upholstered with our signature high-density “can’t cheat-em” foam for maximum feedback</li>
                <li>Precise metal handle placement for upper body support in all exercises</li>
                <li>Super strong and lightweight frame is built to last and still easily moves around studio</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims" style="margin-left: 5px;">
              <p>Width: 16 1/4" (41.28cm)</p>
              <p>Length: 28 ½” (72.4cm)</p>
              <p>Height: 13” (33.0cm)</p>
              <p>Weight: 19lbs. (8.6kg)</p>
            </tab>
          </tabs>
        </section>
      </div>

      <!-- <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for Contrology Arm Chair</h2>
        <div class="accessories">
          <accessory-card
            url="foam-wedge"
            product="Arm Chair"
            src="chair-wedge1@1x.jpg"
            src2="chair-wedge1@2x.jpg"
            alt="Foam Wedge product photo"
            caption="Foam Wedge"
          />
          <accessory-card
            url="arm-chair-springs"
            product="Arm Chair"
            src="armchair-springs1@1x.jpg"
            src2="armchair-springs1@2x.jpg"
            alt="Arm Chair springs close up"
            caption="Arm Chair Springs"
          />
        </div>
      </section> -->

      <!-- <testimonial
        src="quotebanner-armchair@1x.jpg"
        src2="quotebanner-armchair@2x.jpg"
        alt="Photo of student on a Contrology Reformer"
      >
        “The Contrology Arm Chair offers the authenticity I require and the versatility I crave to support and challenge any student.”
        <span>~<a href="https://karenfrischmann.com/" title="Learn more" target="_blank">Karen Frischmann</a></span>
      </testimonial> -->
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/f0JBiPtJ-L8?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
// import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
// import AccessoryCard from "@/components/AccessoryCard.vue";
// import Testimonial from "@/components/Testimonial.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "armchair",

  metaInfo: {
    title: "Contrology Spine Corrector - Balanced Body",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Based on Joe's original dimensions, the Contrology Spine Corrector features the exact angles needed for  authentic feel and function."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    // CtaButton,
    ProdAccordion,
    Tabs,
    Tab,
    // AccessoryCard,
    // Testimonial,
    Modal
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Spine Corrector",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 47553809514689,
          partnumber: "18564",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 47553809449153,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 47553809580225,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 47553809645761,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 47553809711297,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 47553809776833,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 47553809842369,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 47553809907905,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 47553809973441,
          partnumber: "18564C",
          price: 625,
          name: "Contrology Spine Corrector",
          color: "Wedgewood Upholstery",
          available: true
        }
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
        initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
  margin-top: 30px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.accordion-wrapper p {
  margin-left: 30px;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.patent-info {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 130%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
    z-index: 1000;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 85%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    margin-top: 5px;
    max-width: 512px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
